const { onlyNumericNormalize, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyNumericNormalize(zipCode);
  if (zipCode.length <= 5) {
    return zip;
  }
  return `${zip.slice(0, 5)}-${zip.slice(5, 10)}`;
};

exports.countryDefinition = {
  country: 'Saudi Arabia',
  code: 'SA',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postcode',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['city', SPACE, 'zipCode']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['city', 'zipCode']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[0-9]{5}(?:-[0-9]{5})$/),
      error: 'Must be 5+5 numbers, 12233-11564'
    }
  ]
};
